<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <h1>404</h1>
  </div>
</template>

<script>

import SettingsService from '@/services/SettingsService'

export default {
  data () {
    return {
      title: 'Страница не найдена'
    }
  },
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/errors/E404.vue